var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"loadHome":_vm.loadHome}}),(_vm.loadHomePage==true)?_c('AboutWeb'):_vm._e(),(_vm.loadHomePage==true)?_c('Products',{attrs:{"myproducts":_vm.ProductDetails}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }